import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllItemSaleUserSuccess,
  getAllItemSaleUserFailed,
  GET_ALL_ITEM_SALE_USER_START,
} from '../../actions/item'

/**
 * get list item sale user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListItemSaleUserApi = (props) => {
  var uri = `/items`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListItemSaleUser(action) {
  try {
    const response = yield call(getListItemSaleUserApi, action?.payload)
    yield put(getAllItemSaleUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllItemSaleUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list item user
 */
export default function* watchGetListItemSaleUser() {
  yield takeLatest(GET_ALL_ITEM_SALE_USER_START, doGetListItemSaleUser)
}
